import { render } from "./AnagraficaAzienda.vue?vue&type=template&id=b0234ea6&ts=true"
import script from "./AnagraficaAzienda.vue?vue&type=script&lang=ts"
export * from "./AnagraficaAzienda.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__